import React from 'react'
import { Link, useHistory } from "react-router-dom";
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { 
  Progress
} from 'reactstrap';

import MainLayout from '../layouts/MainLayout'
import ProfileFormContainer from '../components/ProfileForm';
import DropboxIntegrationContainer from '../components/DropboxIntegration';
import SubscriptionsTable from '../containers/SubscriptionsTable';
import { useProfile } from '../api/hooks/profile';
import clsx from 'clsx';


function ProfileCard({className, header, children}) {
  return (
    <div className={clsx("card", className)}>
      <div className="card-header">
        <h5 className="font-weight-bold mb-0">{header}</h5>
      </div>
      <div className="card-body">
        {children}
      </div>
    </div>
  )
}

function ProfilePage(props) {
  const { t } = useTranslation('common');
  const { profile } = useProfile();
  const storageUsed = +profile?.storage?.used.toFixed(2) ?? 0;
  const storageCapacity = profile?.storage?.total ?? 25;
  const percentage = (storageUsed / storageCapacity * 100) ?? 0;


  return (
    <MainLayout>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
              <SubscriptionsTable />
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

ProfilePage.propTypes = {

}

export default ProfilePage

